// Mirrors sinek-api/src/utils/feedKey.ts + sportFeedKey.ts (encode only — the
// client never needs to decode this key, only build it to look up or write a
// row). One spelling for every per-feed axis: sport, country and league.
export const encodeFeedKey = (
  entityId: number,
  feed: "line" | "live"
): string => {
  return `${entityId}:${feed}`;
};

export const encodeSportFeedKey = (
  sportId: number,
  feed: "line" | "live"
): string => {
  return encodeFeedKey(sportId, feed);
};
